import { connect } from 'react-redux';
import { translate, InjectedTranslateProps } from 'react-i18next';
import TopMenu from '../TopMenu';

interface StateProps extends InjectedTranslateProps {
}

interface PropsToDispatch {
}

interface OwnProps {
}

const TopMenuContainer = connect<StateProps, PropsToDispatch, OwnProps>(undefined, undefined, undefined, {pure: false})(TopMenu as any);

export default translate()(TopMenuContainer);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Layout/Container/TopMenuContainer.tsx